import React from 'react';
import { formatCurrency } from '../../utils/invoiceFormatters';

const InvoiceLineItems = ({ invoice }) => {
  if (!invoice) return null;

  if (invoice.status === 'FAILED') {
    return (
      <div className="px-4 py-3 bg-red-50 border-l-4 border-red-400 text-sm text-red-700">
        Generation failed. Retry to generate this invoice.
      </div>
    );
  }

  const lineItems = invoice.lineItems || [];
  if (lineItems.length === 0) {
    return (
      <div className="px-4 py-3 text-sm text-gray-400 italic">No line items.</div>
    );
  }

  return (
    <div className="bg-gray-50 px-4 py-3">
      <table className="w-full text-xs">
        <thead>
          <tr className="text-gray-400 uppercase">
            <th className="text-left pb-2 font-medium">Component</th>
            <th className="text-left pb-2 font-medium">Description</th>
            <th className="text-right pb-2 font-medium">Qty</th>
            <th className="text-right pb-2 font-medium">Rate</th>
            <th className="text-right pb-2 font-medium" style={{ color: '#27500A' }}>Amount</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {lineItems.map((item) => (
            <tr key={item.id}
              className={item.mmgFloor && Number(item.mmgFloor) > 0 ? 'bg-amber-50' : ''}>
              <td className="py-1.5 font-medium text-gray-700">{item.component}</td>
              <td className="py-1.5 text-gray-500">{item.description}</td>
              <td className="py-1.5 text-right text-gray-600">{item.quantity}</td>
              <td className="py-1.5 text-right text-gray-600">{formatCurrency(item.unitRate)}</td>
              <td className="py-1.5 text-right font-semibold" style={{ color: '#27500A' }}>
                {formatCurrency(item.amount)}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="border-t border-gray-200 font-semibold">
            <td colSpan={4} className="pt-2 text-gray-700">Total</td>
            <td className="pt-2 text-right" style={{ color: '#27500A' }}>
              {formatCurrency(invoice.totalAmount)}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default InvoiceLineItems;
